import { useSnackbar } from "notistack";
import { GetAllTransactionsUseCase } from "../../../domain/usecase/transaction/getAll/GetAllUseCase";
import { useEffect, useState } from "react";
import { Transaction } from "../../../domain/model/Transaction";
import { State } from "../../../domain/model/ResponseState";

export function TransactionsViewModel(
  getAllTransactionsUseCase: GetAllTransactionsUseCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState<
    Array<Transaction> | undefined
  >([]);

  useEffect(() => {
    getTransactions();
  }, []);

  async function getTransactions() {
    setLoading(true);
    const response = await getAllTransactionsUseCase.invoke();
    switch (response.responseState) {
      case State.Success:
        setTransactions(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
    setLoading(false);
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return { loading, transactions };
}
